
import React, { createContext, useContext, useMemo } from 'react';
import { useAuth } from './AuthContext';

const SportContext = createContext();
export const useSport = () => useContext(SportContext);

export const sportTypes = {
    football: { key: 'football', name: 'Football', icon: '⚽' },
    basketball: { key: 'basketball', name: 'Basketball', icon: '🏀' },
    volleyball: { key: 'volleyball', name: 'Volleyball', icon: '🏐' },
    tennis: { key: 'tennis', name: 'Tennis', icon: '🎾' },
    tabletennis: { key: 'tabletennis', name: 'Ping Pong', icon: '🏓' },
    frisbee: { key: 'frisbee', name: 'Frisbee', icon: '🥏' },
    kitesurfing: { key: 'kitesurfing', name: 'Kitesurfing', icon: '🏄‍♀️🪁' },
    icehockey: { key: 'icehockey', name: 'Ice Hockey', icon: '🏒' },
    baseball: { key: 'baseball', name: 'Baseball', icon: '⚾' },
    rugby: { key: 'rugby', name: 'Rugby', icon: '🏉' },
    americanfootball: { key: 'americanfootball', name: 'American Football', icon: '🏈' },
    fieldhockey: { key: 'fieldhockey', name: 'Field Hockey', icon: '🏑' },
    badminton: { key: 'badminton', name: 'Badminton', icon: '🏸' },
    surfing: { key: 'surfing', name: 'Surfing', icon: '🏄‍♂️' },
    skateboarding: { key: 'skateboarding', name: 'Skateboarding', icon: '🛹' },
    climbing: { key: 'climbing', name: 'Climbing', icon: '🧗‍♀️' },
    skiing: { key: 'skiing', name: 'Skiing', icon: '🎿' },
    snowboarding: { key: 'snowboarding', name: 'Snowboarding', icon: '🏂' },
    cycling: { key: 'cycling', name: 'Cycling', icon: '🚴' },
    running: { key: 'running', name: 'Running', icon: '🏃' },
    boxing: { key: 'boxing', name: 'Boxing', icon: '🥊' },
    swimming: { key: 'swimming', name: 'Swimming', icon: '🏊' },
    yoga: { key: 'yoga', name: 'Yoga', icon: '🧘‍♂️' },
    dance: { key: 'dance', name: 'Dance', icon: '💃' },
    parkour: { key: 'parkour', name: 'Parkour', icon: '🤸' },
    music: { key: 'music', name: 'Music', icon: '🎵' }
};

export const SportProvider = ({ children }) => {
    const { user, updateUser } = useAuth();

    const selectedSportKey = user?.favorite_sport || 'football';

    const selectedSport = useMemo(() => {
        return sportTypes[selectedSportKey] || sportTypes.football;
    }, [selectedSportKey]);

    const setSelectedSportKey = (newVibe) => {
        if (updateUser) {
            updateUser({ favorite_sport: newVibe });
        }
    };
    
    const value = { selectedSport, selectedSportKey, setSelectedSportKey, sportTypes };
    
    return (
        <SportContext.Provider value={value}>
            {children}
        </SportContext.Provider>
    );
};

